import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { AdsStatementDataResponse, AdsStatementPageFactory } from "../../interfaces";
import { AdsStatement } from "../screens/components";

export class AdsStatementPageFactoryImpl implements AdsStatementPageFactory {
    create(adsData: AdsStatementDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!adsData?.success) return <NoDataComponent />
        return <AdsStatement statement={adsData.response} />
    }
}